import { Injectable } from '@angular/core';
import { DataService } from './data.service';
import { Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { AlertService } from './alert.service';
import { LoadingService } from '../sharedModule/loadingModule/loading.service';
import { environment } from 'src/environments/environment';
import { CommonService } from './common.service';

@Injectable({ providedIn: 'root' })
export class HkedCityService {

	public loginResponse:any=null;

	public get userToken():string {
		return localStorage.getItem('hkedCityUserToken') || null;
	}
	public set userToken(token:string) {
		token ? localStorage.setItem('hkedCityUserToken', token) : localStorage.removeItem('hkedCityUserToken');
	}

	public userInfo:any = null;

	public get isLoginByHkedCity():boolean { return (this.userInfo || this.userToken); }
	//在declare時，可能未init data.appId，所以用getter
	private get hkedCityConfig():any { return environment.hkedCity[this.datas.appId] || environment.hkedCity; }
	private get clientId():string { return this.hkedCityConfig.edconnectClientId; }
	private get edconnectUrl():string { return this.hkedCityConfig.edconnectUrl; }
	private get edconnectAuthorizeUrl():string { return this.edconnectUrl + '/oauth2.0/authorize'; }

	private redirectUri:string = document.baseURI + "redirect";// "http://localhost:4200/redirect";//"https://dev.openknowledge.hk/redirect";// "http://localhost:4200/redirect";
	constructor(
		private router:Router,
		private datas:DataService,
		private als:AlertService,
		private lds:LoadingService,
		private coms:CommonService
	) {
		this.checkUserToken();
	}

	private checkUserToken():void {
		// 如果是myaibuddy或xpyqdcs，而且localStorage有hkedCityUserToken(即是之前是用教城SSO登入)，就驗證一下token是否valid
		this.coms.waitFor(()=>this.datas.userInfo, 120, 500).then(()=>{
			//RO用戶可能同時可用教城登入或RO戶口登入
			//留意執行此function時可能是於任何頁面包括login頁
			if (this.isLoginByHkedCity && ['qdcs', 'smartchatai', 'starwishgame', 'rainbowsky'].includes(this.datas.appId)) {
				// 改為於server檢查
				this.datas.post2({ data: { api: 'HkedCity.isTokenValid', json: [this.userToken] }, loading:false }).then((res:any)=>{
					// 如果沒error
					if (res.code==0) {
						// 如果不valid
						if (res.result==false) {
							this.signOut();
						} else if (res.userInfo) {
							this.userInfo = res.userInfo
						}
					} else { //如果error，5分鐘後再檢查
						setTimeout(()=>this.checkUserToken(), 5 * 60 * 1000);
					}
				}).catch((e:any)=>{ //如果error，5分鐘後再檢查
					console.log(e);
					setTimeout(()=>this.checkUserToken(), 5 * 60 * 1000);
				});
			}
		}).catch((e:any)=>{});
	}
	//---------------------------------------------------------------------------------------------
	public loginByHkedCitySSO():void {
		const state:string = btoa(JSON.stringify({
			stateType: "siginHkedCity"
		}));
		//https://edconnect2.hkedcity.net/cas/oauth2.0/authorize?response_type=code&client_id=rainbowsky&redirect_uri=https://app.starwishparty.com/redirect&state=eyJzdGF0ZVR5cGUiOiJzaWdpbkhrZWRDaXR5In0=
		//https://edconnect2.hkedcity.net/cas/oauth2.0/authorize?response_type=code&client_id=rainbowsky&redirect_uri=https://www.rainbowsky.ai/redirect&state=eyJzdGF0ZVR5cGUiOiJzaWdpbkhrZWRDaXR5In0=
		//https://edconnect2-sandbox.hkedcity.net/cas/oauth2.0/authorize?response_type=code&client_id=xpyqdcs_sb&redirect_uri=http://localhost:4200/redirect&state=hkedcity
		const ssoUrl:string = `${this.edconnectAuthorizeUrl}?response_type=code&client_id=${this.clientId}&redirect_uri=${this.redirectUri}&state=${state}`;

		window.location.replace(ssoUrl);
		/*
		redirect返來後的url大概會是這樣:
		http://localhost:4200/redirect?code=OC-3-t4KM9y93-oYEmlDq2RKr2BwTr-7ZWvo9
		*/
	}
	//---------------------------------------------------------------------------------------------
	public linkWithHkedCitySSO():void {
		if (!this.datas || !this.datas.userInfo || !this.datas.userInfo.uid) return;

		const state:string = btoa(JSON.stringify({
			stateType: "linkHkedCity",
			uid: this.datas.userInfo.uid,
		}));
		//https://edconnect2-sandbox.hkedcity.net/cas/oauth2.0/authorize?response_type=code&client_id=xpyqdcs_sb&redirect_uri=http://localhost:4200/redirect&state=hkedcity
		const ssoUrl:string = `${this.edconnectAuthorizeUrl}?response_type=code&client_id=${this.clientId}&redirect_uri=${this.redirectUri}&state=${state}`;

		window.location.replace(ssoUrl);
		/*
		redirect返來後的url大概會是這樣:
		http://localhost:4200/redirect?code=OC-3-t4KM9y93-oYEmlDq2RKr2BwTr-7ZWvo9
		*/
	}
	//---------------------------------------------------------------------------------------------
	public unlinkFromHkedCity():void {
		this.als.yesNoAlert({ 'tc': "確定要解除與香港教育城的連結?", 'sc': "确定要解除与香港教育城的连结?", "en": "Confirm to unlink from HkedCity?" }[this.datas.getLang()||'tc'], null).then((result:string)=>{
			if (result=='yes') {
				this.datas.post2({ data: { api: 'Account.unlink_account_with', json: ["hkedCity"] } }).then((res:any)=>{
					if (res.code==0) {
						this.datas.userInfo.sso = (this.datas.userInfo.sso||[]).filter((sso:any)=>sso.sso_type!='EdConnect');
						this.als.alert2({ 'tc': "成功解除連結！", 'sc': "成功解除连结！", "en": "Unlink successfully." }[this.datas.getLang()||'tc'], null, { btns: [['ok']] }).then(()=>{
							this.signOut();
						});
					} else {
						this.als.alert2({ 'tc': "解除連結失敗！", 'sc': "解除连结失败！", "en": "Fail to unlink." }[this.datas.getLang()||'tc'], null, { btns: [['ok']] });
						// this.signOut();
					}
				});
			}
		});
	}
	//---------------------------------------------------------------------------------------------
	public signInRedirectCallback(signInCode:string):void {

		let apiData:any = [
			"hkedCity",
			{
				signInCode: signInCode,
				redirectUri: this.redirectUri,
			}

		];
		this.datas.post2({ data: { api: 'Account.login_by', json: apiData } }).then((res:any)=>{
			if (res.code==0) {
				//alert('成功登入"香港教育城"的SSO！\nAccessToken: ' + res.accessToken + '\n\n將會自動轉到登入頁面...');
				// const msg:string = '成功以"OAuth 2.0"登入"香港教育城"的"EdConnect"！\n\nAccessToken: ' + res.accessToken + '\n\n從"香港教育城"獲得的用戶資訊:\n' + JSON.stringify(res.userInfo, null, 2);
				// this.als.alert2(msg, null, { containerMaxWidth:"90%", btns: [['ok']] });

				// this.datas.post2({ data: { api: 'Account.testtest', json: [res.hkedCityLoginRes.refresh_token] } }).then((res:any)=>{
				// 	console.log(res);
				// });

				this.loginResponse = res;
				if (res.hkedCityLoginRes.access_token) this.userToken = res.hkedCityLoginRes.access_token;
				this.router.navigate(['/login'], { queryParams: { sso: "hkedCity" } });
			} else {
				(()=>{
					this.lds.removeAll();
					if (res.msg == "noAssocicatedUser") return this.als.alert2({ 'tc': "未有已連結的RO帳戶", 'sc': "未有已连结的RO帐户", "en": "No linked RO account." }[this.datas.getLang()||'tc'], null, { btns: [['ok']] });
					return this.als.alert2({ 'tc': "登入失敗！", 'sc': "登入失败！", "en": "Fail to login." }[this.datas.getLang()||'tc'], null, { btns: [['ok']] });
				})().then(()=>{
					this.signOut();
				});
			}
		});
	}
	//---------------------------------------------------------------------------------------------
	public linkWithRedirectCallback(signInCode:string, uid:string):void {

		let apiData:any = [
			"hkedCity",
			{
				signInCode: signInCode,
				uid: uid,
				redirectUri: this.redirectUri,
			}

		];
		this.datas.post2({ data: { api: 'Account.link_account_with', json: apiData } }).then((res:any)=>{
			if (res.code==0) {
				//alert('成功登入"香港教育城"的SSO！\nAccessToken: ' + res.accessToken + '\n\n將會自動轉到登入頁面...');
				// const msg:string = '成功以"OAuth 2.0"登入"香港教育城"的"EdConnect"！\n\nAccessToken: ' + res.accessToken + '\n\n從"香港教育城"獲得的用戶資訊:\n' + JSON.stringify(res.userInfo, null, 2);
				// this.als.alert2(msg, null, { containerMaxWidth:"90%", btns: [['ok']] });
				this.loginResponse = res;
				if (res.hkedCityLoginRes.access_token) this.userToken = res.hkedCityLoginRes.access_token;
				this.router.navigate(['/home-screen']);
				this.als.alert2({ 'tc': "成功連結至香港教育城", 'sc': "成功连结至香港教育城", "en": "Successfully link with HkedCity." }[this.datas.getLang()||'tc'], null, { btns: [['ok']] });
			} else {
				this.als.alert2({ 'tc': "連結失敗", 'sc': "連結失敗", "en": "Fail to link with HkedCity." }[this.datas.getLang()||'tc'], null, { btns: [['ok']] });
			}
		});
	}
	//---------------------------------------------------------------------------------------------	
	public signOut():void {
		this.userToken = "";
		// 因為教城的server set了CSP不可用iframe，需要直接跳頁再redirect
		window.location.href = `${this.edconnectUrl}/logout?url=${encodeURIComponent(location.origin + "/login")}`;

		// return new Promise((resolve)=>{
		// 	// 建立 iframe 元素
		// 	const iframe = document.createElement("iframe");
		// 	iframe.src = `${this.edconnectUrl}/logout`;
		// 	iframe.style.display = "none";
		// 	// 插入到 body
		// 	document.body.appendChild(iframe);
		// 	this.loginResponse = null;
		// 	this.userToken = null;
		// 	iframe.onload = () => {
		// 		resolve();
		// 		document.body.removeChild(iframe);
		// 		if (!signOutSSOonly) this.roWebLogout();
		// 	};
		// });
	}
	//---------------------------------------------------------------------------------------------
	private roWebLogout():void {
		this.datas.post('Account.logout').subscribe((res: any) => {
			setTimeout(()=>{ //avoid error
				this.datas.userInfo = null;
				this.datas.jwt = '';
				this.datas.jwtObj = null;
				if (localStorage) {
					localStorage.removeItem('common_jwt');
					localStorage.removeItem('common_uid');
					localStorage.removeItem('common_schoolId');
					localStorage.removeItem('common_schoolLogo');
					localStorage.removeItem('common_photo');
					sessionStorage.removeItem('common_photo_done');
					sessionStorage.removeItem('common_schoolLogo_done');
					localStorage.removeItem('homeScreen_data');
				}
				this.router.navigate(['/login']).then(()=>window.location.reload());
				// let url = location.origin + '/login';
				// if (location.port == "") {
				// 	const href = window.location.href;
				// 	url = href.replace(/roWeb.*/, 'roWeb/login');
				// }
				// location.href = url;
			},10);
		});
	}
	//---------------------------------------------------------------------------------------------
	/*public getProfileId():string {
		if (!this.datas || !this.datas.userInfo || !this.datas.userInfo.sso) return null;
		let ssoObj = this.datas.userInfo.sso.find((sso:any)=>sso.sso_type=='EdConnect');
		if (!ssoObj) return null;
		return ssoObj.sso_login_id || null;
	}*/
	//---------------------------------------------------------------------------------------------
	public getStudents(schoolYear:string='', schoolId:string=''):Promise<any[]> {
		return new Promise((resolve)=>{
			const apiData:any[] = [schoolYear, schoolId];
			this.datas.post2({ data: { api: 'HkedCity.getStudents', json: apiData } }).then((res:any)=>{
				if (res.code==0 && res.data) {
					resolve(res.data);
				} else {
					resolve([]);
				}
			});
		});
	}
	//---------------------------------------------------------------------------------------------
	public getTeachers(schoolYear:string='', schoolId:string=''):Promise<any[]> {
		return new Promise((resolve)=>{
			const apiData:any[] = [schoolYear, schoolId];
			this.datas.post2({ data: { api: 'HkedCity.getTeachers', json: apiData } }).then((res:any)=>{
				if (res.code==0 && res.data) {
					resolve(res.data);
				} else {
					resolve([]);
				}
			});
		});
	}
	//---------------------------------------------------------------------------------------------
	public getUserInfo():Promise<any> {
		if (this.userToken) {
			return this.datas.post2({ data: { api: 'HkedCity.getUserInfo', json: [this.userToken] } }).then((res:any)=>{
				if (res.code==0 && res.data) {
					return res.data;
				} else {
					return null;
				}
			});
		} else {
			return Promise.resolve(null);
		}
	}
	//---------------------------------------------------------------------------------------------
	public listProduct():Promise<any[]> {
		return this.datas.post2({ data: { api: 'HkedCity.listProduct', json: [] } }).then((res:any)=>{
			if (res.code==0 && res.data) {
				return res.data;
			} else {
				return null;
			}
		});
	}
	//---------------------------------------------------------------------------------------------
	public listProductSchool():Promise<any[]> {
		return this.datas.post2({ data: { api: 'HkedCity.listProductSchool', json: [] } }).then((res:any)=>{
			if (res.code==0 && res.data) {
				return res.data;
			} else {
				return null;
			}
		});
	}
	//---------------------------------------------------------------------------------------------
	public getSsoMap(schoolId:string):Promise<any[]> {
		return this.datas.post2({ data: { api: 'HkedCity.getSsoMap', json: [schoolId] } }).then((res:any)=>{
			if (res.code==0 && res.data) {
				return res.data;
			}
			return [];
		});
	}
	//---------------------------------------------------------------------------------------------
	public updateSsoMap(schoolId:string, ssoMap:any[]):Promise<any> {
		return this.datas.post2({ data: { api: 'HkedCity.updateSsoMap', json: [schoolId, ssoMap] }, loading:true });
	}
	//---------------------------------------------------------------------------------------------
	//---------------------------------------------------------------------------------------------
	//---------------------------------------------------------------------------------------------
	//---------------------------------------------------------------------------------------------

}
